import React from 'react';
import { Link as ScrollLink } from 'react-scroll';

import StarRating from '../../components/StarRating';

export interface OverallRatingProps {
  reviews: {
    totalReviewCount: number;
    averageStarRating: number;
  };
}

const OverallRating = (props: OverallRatingProps) => {
  const { totalReviewCount, averageStarRating } = props.reviews;

  if (totalReviewCount === 0) {
    return null;
  }

  return (
    <div className="flex items-center space-x-8">
      <StarRating rating={averageStarRating} />

      <ScrollLink to="product-reviews" spy={true} smooth={true} duration={500} offset={-40}>
        <div className="cursor-pointer">({totalReviewCount}&nbsp;reviews)</div>
      </ScrollLink>
    </div>
  );
};

export default OverallRating;
